<template>
  <v-footer
    padless
    class="footer-wrapper"
    :style="{ background: $route.path === '/' ? '#e6f7e8 !important' : 'white !important' }"
  >

    <v-container>
      <v-row class="mt-8 mb-4">
        <!-- <v-col cols="12" md="4" class="mb-6 mb-md-0"> -->
        <v-col cols="12" md="12" class="mb-6 mb-md-0">
          <div class="d-flex align-center mb-4">
              <!-- <v-img 
                src="../../assets/logo.png"
                max-width="32"
                contain
                class="logo-image"
              ></v-img> -->

              <Logo style="margin-left: -4px;"></Logo>

          </div>
          <p class="text-body-1 mb-4" style="color: #616161; line-height: 1.7; font-size: 0.95rem;">
            Transforma tus apuntes en herramientas de estudio interactivas impulsadas por IA. Genera cuestionarios, resúmenes y tarjetas de estudio en segundos.
          </p>
          <div 
          v-if="false"
          class="social-links mb-6">
            <v-btn
              v-for="(social, i) in socials"
              :key="i"
              icon
              class="mr-3 social-btn"
              :href="social.link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <v-icon>{{ social.icon }}</v-icon>
            </v-btn>
          </div>
        </v-col>

        <v-col
        v-if="false"
        cols="6" sm="4" md="2">
          <h3 class="font-weight-bold mb-4" style="font-size: 1.25rem; color: #4b4b4b;">Producto</h3>
          <ul class="footer-links pa-0">
            <li v-for="(link, i) in productLinks" :key="i" class="mb-2">
              <router-link 
                :to="link.route" 
                class="footer-link"
                style="font-size: 0.95rem; color: #616161;"
              >
                {{ link.text }}
              </router-link>
            </li>
          </ul>
        </v-col>

        <v-col
        v-if="false"
        cols="6" sm="4" md="2">
          <h3 class="font-weight-bold mb-4" style="font-size: 1.25rem; color: #4b4b4b;">Recursos</h3>
          <ul class="footer-links pa-0">
            <li v-for="(link, i) in resourceLinks" :key="i" class="mb-2">
              <router-link 
                :to="link.route" 
                class="footer-link"
                style="font-size: 0.95rem; color: #616161;"
              >
                {{ link.text }}
              </router-link>
            </li>
          </ul>
        </v-col>

        <v-col 
        v-if="false"
        cols="6" sm="4" md="2">
          <h3 class="font-weight-bold mb-4" style="font-size: 1.25rem; color: #4b4b4b;">Empresa</h3>
          <ul class="footer-links pa-0">
            <li v-for="(link, i) in companyLinks" :key="i" class="mb-2">
              <router-link 
                :to="link.route" 
                class="footer-link"
                style="font-size: 0.95rem; color: #616161;"
              >
                {{ link.text }}
              </router-link>
            </li>
          </ul>
        </v-col>

        <v-col
        v-if="false"
        cols="6" sm="12" md="2">
          <h3 class="font-weight-bold mb-4" style="font-size: 1.25rem; color: #4b4b4b;">Legal</h3>
          <ul class="footer-links pa-0">
            <li v-for="(link, i) in legalLinks" :key="i" class="mb-2">
              <router-link 
                :to="link.route" 
                class="footer-link"
                style="font-size: 0.95rem; color: #616161;"
              >
                {{ link.text }}
              </router-link>
            </li>
          </ul>
        </v-col>
      </v-row>

      <v-divider class="my-4"></v-divider>

      <div class="py-4 d-flex flex-column flex-sm-row align-sm-center justify-space-between">
        <div class="mb-3 mb-sm-0">
          <span style="font-size: 0.9rem; color: #616161;">
            © {{ new Date().getFullYear() }} SeleAI. Todos los derechos reservados.
          </span>
        </div>
        <div class="d-flex flex-column flex-sm-row align-sm-center">
          <router-link 
            v-for="(link, i) in bottomLinks" 
            :key="i"
            :to="link.route" 
            class="footer-bottom-link mr-sm-4 mb-2 mb-sm-0"
            style="font-size: 0.9rem; color: #616161; text-decoration: none;"
          >
            {{ link.text }}
          </router-link>
        </div>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
import Logo from '../../views/app/components/Logo.vue';

export default {
  name: 'Footer',
  components: {
    Logo
  },
  data: () => ({
    socials: [
      { icon: 'mdi-twitter', link: 'https://twitter.com/seleIA' },
      { icon: 'mdi-instagram', link: 'https://instagram.com/seleIA' },
      { icon: 'mdi-linkedin', link: 'https://linkedin.com/company/seleIA' },
      { icon: 'mdi-facebook', link: 'https://facebook.com/seleIA' }
    ],
    productLinks: [
      { text: 'Cuestionarios', route: '/cuestionarios' },
      { text: 'Resúmenes', route: '/resumenes' },
      { text: 'Tutor IA', route: '/tutor-ia' },
      { text: 'Tarjetas de estudio', route: '/tarjetas' },
      { text: 'Precios', route: '/precios' }
    ],
    resourceLinks: [
      { text: 'Blog', route: '/blog' },
      { text: 'Tutoriales', route: '/tutoriales' },
      { text: 'Biblioteca', route: '/biblioteca' },
      { text: 'API', route: '/api' },
      { text: 'Soporte', route: '/soporte' }
    ],
    companyLinks: [
      { text: 'Sobre nosotros', route: '/sobre-nosotros' },
      { text: 'Contacto', route: '/contacto' },
      { text: 'Carreras', route: '/carreras' },
      { text: 'Afiliados', route: '/afiliados' }
    ],
    legalLinks: [
      { text: 'Privacidad', route: '/privacidad' },
      { text: 'Términos', route: '/terminos' },
      { text: 'Cookies', route: '/cookies' }
    ],
    bottomLinks: [
      { text: 'Privacidad', route: '/privacidad' },
      { text: 'Términos', route: '/terminos' },
      { text: 'Cookies', route: '/cookies' },
      { text: 'Configuración de cookies', route: '/cookies' }
    ]
  })
}
</script>

<style scoped>
.footer-wrapper {
  padding-bottom: env(safe-area-inset-bottom);
  z-index: 1;
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
}

.logo-container {
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: #e6f7d4;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #bfe986;
}

.brand-text {
  background: linear-gradient(90deg, #4dd453, #4fee57);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
  font-size: 1.5rem !important;
  font-weight: 800 !important;
  letter-spacing: -0.03em;
}

.footer-links {
  list-style-type: none;
}

.footer-link {
  position: relative;
  display: inline-block;
  transition: all 0.3s ease;
  opacity: 0.8;
  text-decoration: none;
}

.footer-link::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #4dd453, #4fee57);
  transition: width 0.3s ease;
  border-radius: 2px;
}

.footer-link:hover {
  color: #4dd453 !important;
  opacity: 1;
}

.footer-link:hover::after {
  width: 100%;
}

.social-btn {
  background: #f6fff0 !important;
  border-radius: 16px !important;
  transition: all 0.3s ease;
  color: #616161 !important;
  opacity: 0.8;
  border: 1px solid #e6f7d4;
}

.social-btn:hover {
  background: #e6f7d4 !important;
  transform: translateY(-2px);
  color: #4dd453 !important;
  opacity: 1;
}

.footer-bottom-link {
  position: relative;
  transition: all 0.3s ease;
  opacity: 0.7;
}

.footer-bottom-link:hover {
  opacity: 1;
  color: #4dd453 !important;
}

/* Dark Theme Adjustments */
.theme--dark .footer-wrapper {
  background: #121212 !important;
  border-top-color: rgba(255, 255, 255, 0.05);
}

.theme--dark .logo-container {
  background: rgba(88, 202, 2, 0.2);
  border-color: rgba(88, 202, 2, 0.3);
}

.theme--dark .social-btn {
  background: rgba(88, 202, 2, 0.1) !important;
  color: rgba(255, 255, 255, 0.7) !important;
  border-color: rgba(88, 202, 2, 0.3);
}

.theme--dark .social-btn:hover {
  background: rgba(88, 202, 2, 0.2) !important;
  color: #4dd453 !important;
}

/* Responsive Styles */
@media (max-width: 599px) {
  .brand-text {
    font-size: 1.25rem !important;
  }
  
  .logo-container {
    width: 36px;
    height: 36px;
  }
}
</style> 
